import { TokenPayload } from '@features/auth/store/auth.interface';
import { fromUnixTime, isAfter, isBefore } from 'date-fns';
import jwtDecode from 'jwt-decode';

export function decodeAndValidateAuthToken(token: string): TokenPayload {
  const payload = jwtDecode<TokenPayload>(token);
  const isValid = validateAuthToken(payload.exp, payload.iat);

  if (!isValid) {
    throw new Error('Expired or invalid token');
  }

  return payload;
}

export function validateAuthToken(exp: number, iat: number): boolean {
  const expiresAt = fromUnixTime(exp);
  const issuedAt = fromUnixTime(iat);

  const now = new Date();

  return isAfter(now, issuedAt) && isBefore(now, expiresAt);
}
